module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Beatrix Potter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Beatrix Potter (1866-1943) was an English children’s book writer, best known for her Peter Rabbit series. Born to a wealthy family in English, Beatrix did not go to school and instead stayed at home, spending much of her time drawing and creating stories based on animals. In her 20’s, Beatrix attempted to get her children’s book and drawings published. Finally, in 1902 her first book, "), _c('I', [_vm._v("The Tale of Peter Rabbit")]), _vm._v(", was published, selling over 28,000 copies the first year. This series brought her fame and wealth. She went on to write 23 books. These works have had a profound impact on illustrated children’s books to this day.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DB8wlY/tc-custom/9781532400377.jpg?1702237035171",
      "alt": "This image is the cover for the book Tale of the Flopsy Bunnies, Xist Illustrated Children's Classics"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tale of the Flopsy Bunnies, Xist Illustrated Children's Classics\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Benjamin Bunny’s offspring learn the perils of gluttony in this charming story from the popular author of "), _c('i', [_vm._v("The Tale of Peter Rabbit")]), _vm._v(".")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In this story, Benjamin Bunny’s children, the Flopsy Bunnies, eat so much lettuce from Mr. McGregor’s garden that they become sleepy and are almost turned into a rabbit pie. "), _c('i', [_vm._v("The Tale of the Flopsy Bunnies ")]), _vm._v("by Beatrix Potter is part of the Xist Publishing Children’s Classics collection. Each ebook has been specially formatted with full-screen, full-color illustrations and the original, charming text. \n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Xist Publishing\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0